/**
 * DemoEndSlatePreview — preview of the chosen end-slate for the demo
 * reels. Kept as a founder-only preview so we can iterate on tempo
 * and dimension without republishing the reels themselves.
 *
 * Route: /demo/end-slate-preview  (not linked from anywhere public)
 */

import { useState } from "react";
import { DemoEndSlate } from "../components/DemoEndSlate";
import { useNoIndex } from "../lib/useNoIndex";

export default function DemoEndSlatePreview() {
  useNoIndex();
  const [replayNonce, setReplayNonce] = useState(0);

  return (
    <main
      data-testid="demo-endslate-preview-page"
      className="relative min-h-screen bg-bone px-6 py-14 text-ink lg:px-12 lg:py-20"
    >
      <div className="mx-auto max-w-7xl">
        <header className="mb-10">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-olive">
            End-slate preview
          </p>
          <h1 className="mt-3 font-serif text-4xl leading-tight text-ink lg:text-5xl">
            The closing moment for every reel.
          </h1>
          <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-olive">
            Reuses the signature entrance from the landing hero — the "MY
            RICH AUNT" wordmark and its palette necklace. Triggered on
            Act 06 mount, the animation glides in, the pearls settle, and
            the wordmark holds while the strand catches a slow shimmer.
          </p>
          <button
            type="button"
            onClick={() => setReplayNonce((n) => n + 1)}
            data-testid="preview-replay"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-ink/25 bg-bone px-5 py-2.5 text-sm font-semibold text-ink transition hover:bg-beige"
          >
            Replay animation
          </button>
        </header>

        <section className="rounded-3xl border border-ink/10 bg-sand/30 px-4 py-10 lg:px-8 lg:py-14">
          <div key={replayNonce}>
            <DemoEndSlate onReplay={() => setReplayNonce((n) => n + 1)} />
          </div>
        </section>

        <p className="mt-12 text-center text-[12px] italic text-olive">
          Preview only · not linked from anywhere public · already wired
          into Act 06 of /demo/story, /demo/admin-story, and /demo/donor-story.
        </p>
      </div>
    </main>
  );
}
